;(function($) {

    function Remittances_cnab() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        if($("#modal-remittances-cnab").length > 0) {

            $("#modal-remittances-cnab").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                },
                onOpening: function(modal){ 

                    _.modal = modal;
                    modal.startLoading();

                    $.get(_.API + "bancos/contas", function(data) {
                        
                        _.html = '<form id="form-remittances-cnab" enctype="multipart/form-data">'+
                        '<div class="row">' +                     
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="bank_slips">Banco/Agência/Conta</label>' +
                                    '<select name="bank_slips" id="bank_slips">'+data+'</select>' +
                                '</div>'+
                            '</div>'+                         
                       '</div>'+
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                             
                       '</div></form>';
        
                    }).done(function() {

                        if(_.html != ""){
                            $('#modal-remittances-cnab').iziModal('setTitle', '<i class="fa fa-calendar" aria-hidden="true"></i> Geração do Arquivo Remessa');
                            $("#modal-remittances-cnab .content").html(_.html);

                            _.myForm = $("#form-remittances-cnab").validate({
                                rules: {
                                    contracts_id: { required: true },
                                    users_id: { required: true },
                                    start_date: { required: true},
                                    start_time: { required: true },
                                    ending_date: { required: true },
                                    ending_time: { required: true },
                                    abstract: { required: true },
                                    text_modal: { required: true },
                                    finish_close_ticket: { required: true }
                                },
                                messages: {
                                    contracts_id: { required: "Campo Obrigatório" },
                                    users_id: { required: "Campo Obrigatório" },
                                    start_date: { required: "Campo Obrigatório"},
                                    start_time: { required: "Campo Obrigatório" },
                                    ending_date: { required: "Campo Obrigatório" },
                                    ending_time: { required: "Campo Obrigatório" },
                                    abstract: { required: "Campo Obrigatório" },
                                    text_modal: { required: "Campo Obrigatório" },
                                    finish_close_ticket: { required: "Campo Obrigatório" }
                                },
                                invalidHandler: function(e) {
                                    swal({
                                        title: "Atenção!",
                                        text: "Preencha todos os campos.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK!",
                                        closeOnConfirm: true
                                    });

                                },
                                submitHandler: function( form ) {

                                    for(instance in CKEDITOR.instances) {
                                        CKEDITOR.instances[instance].updateElement();
                                    }
                                
                                    $("#form-remittances-cnab .btn-send").html("Enviando...");
                                    
                                    $.ajax({
                                        type: "POST",
                                        url: _.API + "agenda",
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        data: new FormData(form),
                                        success: function(result)
                                        {
                                            $("#form-remittances-cnab .btn-send").html("Enviar");

                                            form.reset();

                                            $('#modal-remittances-cnab').iziModal('close'); 

                                            swal({
                                                title: result.message,
                                                text: "Click no botão para fechar!",
                                                type: "success",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: false
                                            }).then(function() {
                                              location.reload();
                                            });                                        
                                        },
                                        error: function(response) {
                                            var errors = $.parseJSON(response.responseText);
                                            
                                            swal({
                                                title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                                text: "Click no botão para fechar!",
                                                type: "warning",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: true
                                            });

                                           
                                            $myForm.showErrors(errors);
                                            
                                            $("#form-remittances-cnab .btn-send").html("Enviar");
                                        }
                                    });
                                }
                            });
                        }
                    });                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-remittances-cnab .content").html("");
                    $('#modal-remittances-cnab').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-create-remittances-cnab").on("click", function(e){
            e.preventDefault();
            $('#modal-remittances-cnab').iziModal('open');           
        });
    } 

   	new Remittances_cnab();

}(jQuery));